import { Pipe, PipeTransform } from '@angular/core';
import {
  OnlineOfflineUserStatus as DatastoreOnlineOfflineStatusObject,
  OnlineOfflineUserStatusValue as DatastoreOnlineOfflineStatus,
} from '@freelancer/datastore/collections';
import { assertNever } from '@freelancer/utils';

@Pipe({ name: 'isOnline' })
export class IsOnlinePipe implements PipeTransform {
  transform(
    user: { id: number },
    onlineOfflineStatuses?: readonly DatastoreOnlineOfflineStatusObject[],
  ): boolean {
    if (!onlineOfflineStatuses) {
      return false;
    }

    const matchingStatus = onlineOfflineStatuses.find(
      status => status.id === user.id,
    );

    if (!matchingStatus) {
      return false;
    }

    switch (matchingStatus.status) {
      case DatastoreOnlineOfflineStatus.ONLINE:
        return true;
      case DatastoreOnlineOfflineStatus.OFFLINE:
        return false;
      default:
        return assertNever(matchingStatus.status);
    }
  }
}
